module.exports = __webpack_public_path__ + "static/media/result_ns_ja_old.2e04ba34.jpg";